import fill from './fill.js';

const reset = (array, i, j) => fill(array, 0, i, j);
export default reset;
